import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  BrowserRouter,
  Redirect
} from "react-router-dom";

import TerminosCondiciones from "./Components/TerminosCondiciones/TerminosCondiciones";
import Privacy from "./Components/Privacy/Privacy";
import Ecommerce from "./Components/Ecommerce/Ecommerce";

function App() {

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          component={Ecommerce}
        ></Route>
        <Route
          exact
          path="/terminos-y-condiciones"
          component={TerminosCondiciones}
        ></Route>
        <Route exact path="/aviso-de-privacidad" component={Privacy} />
        <Route path="/" render={() => <Redirect to="/" />} />ž
      </Switch>
    </BrowserRouter>
  );
}

export default App;
